export const INSTAGRAM_FEED_TITLE_UPDATE = 'INSTAGRAM_FEED_TITLE_UPDATE';
export const INSTAGRAM_FEED_LAYOUT_UPDATE = 'INSTAGRAM_FEED_LAYOUT_UPDATE';
